import React from 'react';

export default function MagicWandOutlined({ style }: { style?: React.CSSProperties; }) {
	return (
		<span role="img" aria-label="baguette" className="anticon" style={style}>
			<svg
				viewBox="0 0 24 24"
				focusable="false"
				width="1em"
				height="1em"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				aria-hidden="true"
			>
				<path d="M4 20 15 9" />
				<path d="m14 6 4 4" />
				<path d="M18 2v3M16.5 3.5h3" />
				<path d="M7 4v2M6 5h2" />
				<path d="M20 13v2M19 14h2" />
			</svg>
		</span>
	);
}
